/**
 * E2 -- a page that does not exist says so, inside the shell.
 *
 * There was no catch-all route, so a mistyped or stale URL rendered a
 * completely blank page: no chrome, no navigation, no way back. A
 * person who followed an old link from an email had nothing to click
 * and no indication anything was wrong.
 */
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function NotFoundView() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  return (
    <article data-testid="not-found-view" className="max-w-2xl space-y-3">
      <h1 className="font-display text-2xl text-slate-900">{t("notFound.heading")}</h1>
      <p className="text-sm text-slate-600">
        {t("notFound.body")}{" "}
        <code data-testid="not-found-path" className="text-xs text-slate-500">
          {pathname}
        </code>
      </p>
      <p className="text-sm">
        <Link
          data-testid="not-found-home"
          to="/"
          className="font-medium text-brand-brassDark hover:underline"
        >
          {t("notFound.home")}
        </Link>
        {" · "}
        <Link
          data-testid="not-found-my-work"
          to="/my-work"
          className="font-medium text-brand-brassDark hover:underline"
        >
          {t("notFound.myWork")}
        </Link>
      </p>
    </article>
  );
}
